import { useContext } from 'react';

import Localecontext from '@/modules/context/localeContext';

export const useLocale = () => useContext(Localecontext);
